"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (theme) => ({
    pageWrapper: {
        paddingLeft: theme.defaults.content.paddingLeftMobile,
        paddingRight: theme.defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: theme.defaults.content.paddingLeft,
            paddingRight: theme.defaults.content.paddingRight,
        },
    },
    hide: {
        display: 'none',
    },
    appFrame: {
        height: theme.defaults.content.height,
        width: '100%',
        minWidth: theme.defaults.content.pageMinWidth,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    appBar: {
        borderRadius: 0,
        opacity: 0.86,
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.border.default}`,
        background: theme.palette.background.paper,
        zIndex: 1,
        height: theme.defaults.headers.headerHeight,
        position: 'absolute',
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolBar: {
        minHeight: theme.defaults.headers.headerHeight,
        boxShadow: 'none',
        paddingLeft: theme.defaults.content.paddingLeftMobile,
        paddingRight: theme.defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: theme.defaults.content.paddingLeft,
            paddingRight: theme.defaults.content.paddingRight,
        },
    },
    content: {
        overflowY: 'auto',
        fontWeight: '200',
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        height: `calc(100% - ${theme.defaults.headers.headerHeight}px)`,
        marginTop: theme.defaults.headers.headerHeight,
        borderBottom: `1px solid ${theme.palette.background.elevated}`,
    },
    listItemTextContent1: {
        textAlign: 'left',
        fontWeight: '200',
        fontSize: 13,
        '&.header': {
            fontWeight: 400,
            paddingRight: 0,
        },
    },
    selectedAccount: {
        borderBottom: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: theme.palette.background.elevated,
        borderTop: 'solid',
        borderTopWidth: 1,
        borderTopColor: theme.palette.background.subtle,
        backgroundColor: theme.palette.background.subtle,
    },
    listHeader: {
        backgroundColor: theme.palette.background.subtle,
    },
    headerOpenIcon: {
        width: 16,
        height: 24,
    },
    headerOpenIconSvg: {
        marginLeft: 12,
    },
    settingsIcon: {
        color: theme.palette.background.elevated,
    },
    menuHolder: {
        marginTop: -4,
        display: 'inline',
        height: 'inherit',
        width: 46,
    },
    listItemTextContent2: {
        textAlign: 'right',
        fontWeight: '400',
        fontSize: 13,
        '&.header': {
            fontWeight: 400,
            paddingRight: 0,
        },
    },
    rightSideContent: {
        textAlign: 'right',
        marginRight: '10px',
        marginLeft: 'auto',
        fontWeight: '200',
        lineHeight: '54px',
        marginTop: 2,
    },
    inlineText: {
        marginLeft: '10px',
        fontWeight: '400',
        fontSize: '16px',
        '&.with-icon': {
            marginRight: 32,
        },
    },
    inlineTextBalance: {
        fontWeight: '200',
        fontSize: '12px',
        lineHeight: '13px',
        display: 'inline-block',
    },
    positiveBal: {
        color: theme.palette.amount.positive,
        fontWeight: '400',
    },
    negativeBal: {
        color: theme.palette.amount.negative,
        fontWeight: '400',
    },
    positiveBalDark: {
        color: theme.palette.amount.positive,
    },
    negativeBalDark: {
        color: theme.palette.amount.negative,
    },
    balanceMenu: {
        display: 'inline-block',
        width: '20px',
        marginRight: 7,
        marginLeft: 5,
        height: 16,
    },
    balanceWrapper: {
        display: 'inline-block',
        lineHeight: 0,
        verticalAlign: 'middle',
        borderBottom: 'none',
        borderBottomWidth: '1px',
        borderBottomColor: theme.palette.background.elevated,
        marginTop: '0px',
    },
    loadingStateContainer: {
        display: 'flex',
        width: '100%',
        height: 500,
        justifyContent: 'center',
        alignItems: 'center',
    },
    zeroStateContainer: {
        height: '100%',
        width: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    zeroStateContent: {
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100% - ${theme.defaults.headers.headerHeight}px)`,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        color: theme.palette.text.secondary,
    },
    zeroStateTextHeadline: {
        marginBottom: 10,
        fontWeight: 500,
        margin: '10px 0 10px 0',
    },
    zeroStateTextBody: {
        textAlign: 'center',
        maxWidth: '80%',
    },
    underConstructionContainer: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 271,
        justifyContent: 'center',
        alignItems: 'center',
    },
    accountNodeImg: {
        height: 64,
        width: 64,
    },
    mainGridRow: {
        display: 'relative',
        justifyContent: 'flex-end',
        width: '100%',
        paddingLeft: 0,
        paddingRight: 0,
    },
    mainGrid: {
        paddingBottom: 24,
        paddingTop: 24,
    },
});
exports.styles = styles;
